import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

import Modal from "react-modal";
import { Bars } from "react-loader-spinner";

import {setSocialHandleOnBackend} from '../../utils/backendUtils'
import CancelIcon from "../../assets/cancel_icon.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import supermessage from '../../assets/powers/supermessage.png';
import flashbang from '../../assets/powers/flashbang.png';
import autograph from '../../assets/powers/autograph.png';
import supermessage_asset from '../../assets/powers/supermessage_asset.png';
import flashbang_asset from '../../assets/powers/flashbang_asset.png';
import autograph_asset from '../../assets/powers/autograph_asset.png';

const HeaderSpan  = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  text-align: center;
`

const InputContainerDiv = styled.div`
  width: 398px;
  height: 44px;
  display:flex;
  border: 1px solid rgba(255, 255, 255, 0.08);
  align-items: center;
`

const StyledInput = styled.input`
  width: 326px;
  height: 19px;
  background: #131313;
  padding: 11px 16px;
  display: flex;
  align-items: center;
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  border: none;
  color: white;
  :placeholder,
  :-webkit-input-placeholder {
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: rgba(255, 255, 255, .4);
  }
`

const ActionButtonDiv = styled.div`
  width: 398px;
  height: 44px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  cursor: pointer;
`

const ActionButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`

const Button = styled.div`
    font-weight: 700;
    font-size: 14px;
    color: #fff;
    background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
    border-radius: 12px;
    padding: 13px;
    width: 100%;
    margin-top: 60px;
    text-align: center;
`;



const GreenButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: rgba(0, 126, 34, 1);
    background-blend-mode: overlay;
    border-radius: 12px;
`;


const LightPurpleButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: rgba(151, 32, 228, 1);
    background-blend-mode: overlay;

    border-radius: 12px;
`;


const PurpleButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: #650054;
    border-radius: 12px;
`;


const PowersWrapper = styled.div`
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    margin-bottom: 25px;
`;


const PowersStock = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    /* identical to box height, or 21px */

    letter-spacing: 0.05em;
    text-transform: uppercase;

    color: #FFFFFF;
    margin-top: 14px;
`;

const PowersTitle = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 90.1%;
    /* or 18px */

    text-align: center;

    color: #FFFFFF;
    margin-top: 8px;
`;

/*
  Start animation for chest opening, once animation is done show the perks won.
  Make API call to fetch the perks, available after chest is opened

*/
export default function PerkWinOverlay(props:any){

    let modalWidth = "446px";
    let modalHeight = "270px";    
    const [videoDone, setVideoDone] = useState(true);
    const history = useHistory();
    
    
    if(!videoDone) {
        return (
            <Modal
                isOpen={props.isOpen}
                style={{
                content: {
                    background: "#000",
                    width: '100vw',
                    height: '100vh',
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "auto",
                    marginBottom: "auto",
                    border:"none",
                    padding: 0,
                }}}
            >
            <video
                src={'https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/video/NFT+Lootbox+1.mp4'}
                onEnded={() => {console.log('ended'); setVideoDone(true)}}
                autoPlay
                style={{width: '100vw', height: '100vh'}}
            />
            </Modal>
        );
    }
    return (
        <Modal
	    isOpen={props.isOpen}
	    style={{
		content: {
		    background: "#0F0F0F",
		    width: modalWidth,
		    height: modalHeight,
		    marginLeft: "auto",
		    marginRight: "auto",
		    marginTop: "auto",
		    marginBottom: "auto",
		    border:"none",
            width: '100vw',
            height: '100vh',
            padding: 0,
            inset: 0,
	    }}}
	>
            <div style={{
	        display: 'flex',
	        flexDirection: 'column',
	        position: 'relative',
	        alignItems: 'center',
            height: '100%',
            justifyContent: 'center',
            }}>
                <img onClick={()=>{setVideoDone(false);props.handleModalCloseEvent()}}
		     src={CancelIcon}
		     style={{
		         position: "absolute", opacity: 0.4,
		         height: 14, width:14,
		         right:40, cursor:"pointer",
		         zIndex:10, top: 40
		     }}
	        />
                <div style={{maxWidth: 750, width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                    <HeaderSpan>
                        DRUMROLL... <br></br>HERE'S YOUR LOOT
                    </HeaderSpan>
                    <div style={{display: 'flex', marginLeft: -20, marginTop: 24}}>
                        {/* <div className="shield"></div> */}
                        <div 
                            style={{
                                background: `url('${autograph}')`,
                                marginLeft: 20,
                                width: 190,
                                height: 270,
                                display: 'flex',
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }} >
                                <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center', height: '100%'}}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}>
                                        <PowersStock>8 items in stock</PowersStock>
                                        <PowersTitle>AUTOGRAPH COLLECTIBLE</PowersTitle>
                                        <img style={{marginTop: 36}} src={autograph_asset} />
                                    </div>
                                    <PurpleButton className="hover">BUY $12</PurpleButton>
                                </div>
                        </div>
                        <div 
                            style={{
                                background: `url('${supermessage}')`,
                                marginLeft: 20,
                                width: 190,
                                height: 270,
                                display: 'flex',
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }} >
                                <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center', height: '100%'}}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}>
                                        <PowersStock>18 items in stock</PowersStock>
                                        <PowersTitle>SUPERMESSAGE ON STREAM</PowersTitle>
                                        <img style={{marginTop: 36}} src={supermessage_asset} />
                                    </div>
                                    <GreenButton className="hover">BUY $12</GreenButton>
                                </div>
                        </div>
                        <div 
                            style={{
                                background: `url('${flashbang}')`,
                                marginLeft: 20,
                                width: 190,
                                height: 270,
                                display: 'flex',
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }} >
                                <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center', height: '100%'}}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}>
                                        <PowersStock>32 items in stock</PowersStock>
                                        <PowersTitle>FLASHBANG OVERLAY EFFECT</PowersTitle>
                                        <img style={{marginTop: 36}} src={flashbang_asset} />
                                    </div>
                                    <LightPurpleButton className="hover">BUY $12</LightPurpleButton>
                                </div>
                        </div>                       
                    </div>
                    {/* <InputContainerDiv style={{marginTop: 24}}>
                        <StyledInput
                            placeholder={"Enter your intagram @"}
                            value={instagramText}
                            type="text"
                            onChange={e =>handleInstagramText(e.target.value)}
                        />
                    </InputContainerDiv>
                    <InputContainerDiv style={{marginTop: 12}}>
                        <StyledInput
                            placeholder={"Enter your discord ID"}
                            value={discordText}
                            type="text"
                            onChange={e =>handleDiscordText(e.target.value)}
                        />
                    </InputContainerDiv> */}
                
                    <Button
                        className="hover"
                        // onClick={() => history.push(`/perks/claim/${props.username}/${props.serial}`)}
                        onClick={() => history.push(`/perks/claim/`)}
                    >USE PERKS</Button>
                </div>
                {/* <ActionButtonDiv onClick={
                ()=>{handleSubmitClick(instagramText,discordText)}}>
                    {(!showLoader) && (
                        <ActionButtonTextSpan>
                            SUBMIT INFO
                        </ActionButtonTextSpan>
                    )}
                    {(showLoader) && (
                        <Bars
                            heigth="30" width="30"
                            color="grey"
                            ariaLabel="loading-indicator" />
                    )}
                </ActionButtonDiv> */}
            </div>
        </Modal>
    );
}
